'use es6';

import OccurrenceLabel from 'ContentComponents/cmv2/occurrences/OccurrenceLabel';
import { getImmutableOrPlain } from './dataHelpers';
import { Iterable } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
const convertImmutableMapToObject = mapModule => Iterable.isIterable(mapModule) ? mapModule.toJS() : mapModule;
const getModuleFieldLabel = (path, module, schema, resources) => {
  let fields = schema.fields;
  let field = null;
  let value = null;
  const labels = [];
  path.forEach((fieldName, index) => {
    if (field && field.occurrence) {
      if (value) {
        value = value.get(Number(fieldName));
      }
      // OccurenceLabel component expects a simple object type instead of a map
      value = convertImmutableMapToObject(value);
      labels.push( /*#__PURE__*/_jsx(OccurrenceLabel, {
        asString: true,
        defaultLabel: `${field.label} ${Number(fieldName) + 1}`,
        field: field,
        value: value,
        resources: resources
      }, field));
      field = null;
      if (index < path.length - 1) {
        labels.push( /*#__PURE__*/_jsx("span", {
          children: ', '
        }, `${index}_comma`));
      }
    } else if (field && field.type === 'email') {
      field = null;
    } else {
      const moduleBody = getImmutableOrPlain(module, 'body', null);
      value = moduleBody ? getImmutableOrPlain(moduleBody, fieldName) : undefined;
      field = fields.find(f => f.name === fieldName);
      if (field) {
        fields = field.children || [];
        labels.push( /*#__PURE__*/_jsx("span", {
          children: field.label
        }, `${index}_${field.label}`));
        if (index < path.length - 1) {
          labels.push( /*#__PURE__*/_jsx("span", {
            children: ', '
          }, `${index}_comma`));
        }
      }
    }
  });
  return /*#__PURE__*/_jsx("a", {
    children: labels
  });
};
export const normalizeModuleErrorTokens = (module, schema, tokens, resources) => {
  if (tokens.id) {
    if (module) {
      tokens.id = getImmutableOrPlain(module, 'id');
      tokens.moduleName = getImmutableOrPlain(module, 'label');
      if (tokens.path) {
        const pathParts = tokens.path.split('.');
        if (pathParts.length > 0) {
          const fieldLabel = getModuleFieldLabel(pathParts, module, schema, resources);
          tokens.fieldLabel = fieldLabel;
        }
      }
      return tokens;
    }
    return null;
  }
  return tokens;
};